import { Flex, Heading, Image } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { Fade, Bounce } from "react-awesome-reveal";
import { FormattedMessage } from "react-intl";
import InfoCard from "../../../../components/InfoCard/InfoCard";
import Loading from "../../../../components/Loading/Loading";

const InfoUserDesktop = ({ info }) => {
  const [itemsShowed, setItemsShowed] = useState(false);

  useEffect(() => {
    if (info) {
      const timeout = info.length * 500;
      console.log(timeout);
      setTimeout(() => {
        setItemsShowed(true);
      }, timeout);
    }
  }, [info]);

  return (
    <>
      {info ? (
        <Flex
          flexWrap="wrap"
          justify="center"
          flexDir="column"
          w="100%"
          pt="60px"
          backgroundColor="#ff6e6c"
          minH="87vh"
        >
          <Heading
            color="#FFFFFF"
            textAlign="center"
            mb="50px"
            fontWeight="bold"
            fontSize="50px"
          >
            <Fade cascade triggerOnce damping={0.05}>
              <FormattedMessage
                id="app.info.heading"
              />
            </Fade>
          </Heading>
          <Flex flexWrap="wrap" justify="center" align="center">
            <Fade triggerOnce cascade>
              {info.map((noticia) => {
                return <InfoCard key={noticia._id} noticia={noticia} />;
              })}
            </Fade>
          </Flex>
          {itemsShowed ? (
            <Bounce triggerOnce>
              <Flex
                mt="60px"
                justify="center"
                align="center"
                w="100%"
                h="400px"
                flexDir="column"
              >
                <Image
                  mt="20px"
                  w="100px"
                  mb="-5px"
                  src="/assets/dancing.gif"
                  alt="bailoteo gif gracioso"
                />
                <Image
                  w="650px"
                  h="300px"
                  mb="50px"
                  borderRadius="10px"
                  src="https://res.cloudinary.com/dhp2zuftj/image/upload/v1647028958/MontseProyect/LogoBlanco.png"
                  alt="icono KLS"
                />
              </Flex>
            </Bounce>
          ) : (
            <Flex
              mt="60px"
              h="400px"
              justify="center"
              align="center"
              w="100%"
              flexDir="column"
            ></Flex>
          )}
        </Flex>
      ) : (
        <Flex
          w="100vw"
          h="87vh"
          backgroundColor="#ff6e6c"
          justify="center"
          align="center"
        >
          <Loading />
        </Flex>
      )}
    </>
  );
};

export default InfoUserDesktop;
